import * as React from 'react';
import './dashboard-card.css';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { SvgIcon } from '@mui/material';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

//substituir esse numero por uma função que pega o numero de pedidos e amostras
interface BasicCardProps {
    info: {
        title: string;
        valor: number;
        icon: string;
    }
}

export default function BasicCard({ info }: BasicCardProps) {
  return (
    <Card className='dashboard-card'>
      <CardContent>
        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 16 }}>
          {info.title}
        </Typography>
        <Typography gutterBottom className='dashboard-data'> 
          {info.valor}
        </Typography>
      </CardContent>
      <CardContent>
        <Box
            className="dashboard-icon"
            sx={{ width: 50, height: 50 }}
            dangerouslySetInnerHTML={{ __html: info.icon }} 
          />
      </CardContent>
    </Card>
  );
}
